export default Object.freeze({
  Reposicion: 1,
  Regresion: 2,
});
